import { useState } from 'react'

export default function MobileSearchBar({
  value,
  onChange,
  onFilterClick,
  activeFiltersCount = 0,
  placeholder = "Search projects..."
}) {
  const [isFocused, setIsFocused] = useState(false)

  return (
    <div className="sticky top-16 z-40 bg-white border-b border-secondary-200 px-4 py-3">
      <div className="flex items-center gap-2">
        <div className={`flex-1 flex items-center gap-2 px-4 py-2.5 bg-secondary-50 rounded-lg transition-all ${
          isFocused ? 'ring-2 ring-primary-500' : ''
        }`}>
          <svg className="w-5 h-5 text-secondary-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
          <input
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            placeholder={placeholder}
            className="flex-1 bg-transparent border-none outline-none text-sm text-secondary-900 placeholder-secondary-400"
          />
          {value && (
            <button
              onClick={() => onChange('')}
              className="p-1 hover:bg-secondary-200 rounded-full transition-colors"
              aria-label="Clear search"
            >
              <svg className="w-4 h-4 text-secondary-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          )}
        </div>

        <button
          onClick={onFilterClick}
          className="relative flex items-center justify-center min-w-[44px] min-h-[44px] bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
          aria-label="Filters"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
          </svg>
          {activeFiltersCount > 0 && (
            <span className="absolute -top-1 -right-1 bg-error-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
              {activeFiltersCount}
            </span>
          )}
        </button>
      </div>
    </div>
  )
}
